<template>
<div>
  <div class="d-flex" id="wrapper">
    <SideBar />
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
          <p class="text-muted mb-0 hover-cursor link" @click="$toCatalogProduct($router)">&nbsp;Catalog / Product</p>
          <p class="text-primary mb-0 hover-cursor">&nbsp;/&nbsp;BOM</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="container">
          <div class="row justify-content-center">
            <h4 class="py-3 my-3 m-auto">BOM</h4>
          </div>
          <h6 class="my-3" style="font-weight: bold">{{bomDevice}}</h6>
          <button class="btn btn-primary mt-2" @click="toPage('/catalog/bom/add/' + deviceId + '?unit=' + isUnit)">Add BOM</button>
          <div v-if="loading == false">
            <div class="row" v-if="bomData && bomData.length > 0">
              <div class="col-md-4 my-3" v-for="data in bomData" :key="data.name">
                <div class="col-lg-12 py-3 bordered rounded" style="min-height: 175px">
                  <h6 class="mb-1" style="font-weight: bold">{{data.bomName}}</h6>
                  <div v-for="item in data.itemBom" :key="item.itemName">
                    <p class="mb-0" v-for="loop in item.itemQty" :key="loop">
                      {{item.itemName}}
                    </p>
                  </div>
                </div>
                <button class="btn btn-info w-100 py-1 my-1" @click="removeBom(data.bomName)">Remove</button>
              </div>
            </div>
            <div class="row justify-content-center align-items-center" v-else>
              <h6 class="my-5">List is Empty.</h6>
            </div>
          </div>
          <div v-else>
            <div class="row justify-content-center align-items-center py-5">
              <img src="~@/assets/images/load-button.gif" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="modalRemoveBom" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <div class="change-title">
            <h4 class="modal-title">Remove BOM</h4>
          </div>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          Apakah anda yakin ingin menghapus {{selectedBom}} ?
        </div>
        <div class="modal-footer">
          <div class="container">
            <div class="row justify-content-end align-items-center">
              <div v-if="!isLoadingRemoveBom" class="col-md-2 pl-0 pr-1">
                <button class="btn btn-sm btn-danger w-100" @click="cancelRemove">Cancel</button>
              </div>
              <div v-if="!isLoadingRemoveBom" class="col-md-2 pr-0 pl-1">
                <button class="btn btn-sm btn-primary w-100 px-1" @click="confirmDelete">OK</button>
              </div>
              <div v-if="isLoadingRemoveBom" class="pr-0 pl-1 container justify-content-end d-flex">
                <button
                type="button"
                style="gap:10px"
                class="btn btn-primary btn-sm d-flex align-items-center"
                disabled
              >
                <img src="~@/assets/images/2.gif" style="height: 24px" />Saving
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import SideBar from "../SideBar";
import CONSTANT from "../constPlugin";
export default {
  name: 'CatalogBom',
  components: {
    SideBar
  },
  data() {
    return {
      bomDevice: '',
      deviceId: '',
      isUnit: true,
      bomData: [],
      selectedBom: '',
      loading: true,
      isLoadingRemoveBom: false
    }
  },
  methods: {
    toPage(e) {
      this.$router.push(e)
    },
    getBom() {
      this.$http.get(process.env.GET_CATALOG_BOM + this.deviceId, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt"),
          }
        })
        .then(res => {
          if (res.status == 200) {
            console.log(res)
            this.bomData = res.data.content
          }
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    removeBom(code) {
      this.selectedBom = code
      $('#modalRemoveBom').modal('show')
    },
    confirmDelete() {
      this.isLoadingRemoveBom = true
      this.$http.get(process.env.REMOVE_CATALOG_BOM_NEW + this.selectedBom, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt"),
          },
        })
        .then(res => {
          this.isLoadingRemoveBom = false
          if (res.data.status == 200) {
            $('#modalRemoveBom').modal('hide')
            swal('Success', this.selectedBom + ' Berhasil dihapus.', 'success')
            this.getBom()
            this.selectedBom = ''
          } else {
            $('#modalRemoveBom').modal('hide')
            swal('Error', res.data.message, 'error').then(() => {
              $('#modalRemoveBom').modal('show')
            })
          }
        }).catch(error => {
          this.isLoadingRemoveBom = false
          $('#modalRemoveBom').modal('hide')
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            } else {
              $('#modalRemoveBom').modal('show')
            }
          })
        })
    },
    cancelRemove() {
      this.selectedBom = ''
      $('#modalRemoveBom').modal('hide')
    },
    getItem() {
      this.$http.post(process.env.GET_CATALOG_EDIT, {
          catalogId: Number(this.deviceId),
          isUnit: this.isUnit,
        }, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt"),
          },
        })
        .then(res => {
          console.log(res)
          let data = res.data.content
          let type = ''
          CONSTANT.PRODUCT_TYPE.forEach(el => {
            if (el.status == data.productType) {
              type = el.statusName
            }
          })
          this.bomDevice = `${type} - ${data.name} ${data.productDetail.processor} / ${data.productDetail.ram} GB / ${data.productDetail.storage} / ${data.productDetail.vga}`

        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    cekPermission() {
      this.permission = localStorage.getItem("roles").replace(/"/g, "").replace("[", "").replace("]", "").split(",");
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true;
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true;
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true;
        }
        if (this.permission[i] == "3.1") {
          this.viewReturn = true;
        }
        if (this.permission[i] == "3.2") {
          this.editReturn = true;
        }
        if (this.permission[i] == "4.1") {
          this.viewProduct = true;
        }
        if (this.permission[i] == "4.2") {
          this.editProduct = true;
        }
        if (this.permission[i] == "5.1") {
          this.viewPairing = true;
        }
        if (this.permission[i] == "5.2") {
          this.editPairing = true;
        }
        if (this.permission[i] == "6") {
          this.viewReconcile = true;
        }
        if (this.permission[i] == "7.1") {
          this.viewResolution = true;
        }
        if (this.permission[i] == "7.2") {
          this.editResolution = true;
        }
        if (this.permission[i] == "8.1") {
          this.viewLessor = true;
        }
        if (this.permission[i] == "8.2") {
          this.editLessor = true;
        }
        if (this.permission[i] == "9.1") {
          this.viewLessee = true;
        }
        if (this.permission[i] == "9.2") {
          this.editLessee = true;
        }
        if (this.permission[i] == "10") {
          this.viewEmployee = true;
        }
      }
      if (this.editProduct == false) {
        this.$router.push("/");
      }
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push("/");
    },
  },
  created() {
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.deviceId = this.$route.params.id
    this.isUnit = Boolean(this.$route.query.unit); 
    this.cekLogin();
    this.cekPermission();
    this.getItem()
    this.getBom()
  }
}
</script>

<style scoped>
.bordered {
  border: 1px solid gray;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalog/CatalogBomPage.vue